import { useState, useCallback } from 'react';
import { analyzeSkills, type SkillAnalyzeInput, type AnalyzedSkill } from '@/services/ai';

interface UseSkillAnalyzerReturn {
  skills: AnalyzedSkill[];
  isLoading: boolean;
  error: string | null;
  analyze: (input: SkillAnalyzeInput) => Promise<void>;
  reset: () => void;
}

export function useSkillAnalyzer(): UseSkillAnalyzerReturn {
  const [skills, setSkills] = useState<AnalyzedSkill[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const analyze = useCallback(async (input: SkillAnalyzeInput) => {
    setIsLoading(true);
    setError(null);

    try {
      const result = await analyzeSkills(input);
      setSkills(result);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'エラーが発生しました');
    } finally {
      setIsLoading(false);
    }
  }, []);

  const reset = useCallback(() => {
    setSkills([]);
    setError(null);
  }, []);

  return { skills, isLoading, error, analyze, reset };
}
